import { Routes, Route } from "react-router-dom";
import Home from "views/Home";
import About from "views/About";
import Interest from "views/Interest/Interest";
import ReviewInterest from "views/Interest/ReviewInterest";
import Feedback from "views/Feedback";
import ThankYou from "views/ThankYou";
import NotFound from "views/Error/NotFound";
import Styleguide from "views/Styleguide";
import PrivateRoute from "./PrivateRoute";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/interest-selection" element={<Interest />} />
      <Route
        path="/review-interests"
        element={
          <PrivateRoute>
            <ReviewInterest />
          </PrivateRoute>
        }
      />
      <Route
        path="/give-feedback"
        element={
          <PrivateRoute>
            <Feedback />
          </PrivateRoute>
        }
      />
      <Route
        path="/thank-you"
        element={
          <PrivateRoute>
            <ThankYou />
          </PrivateRoute>
        }
      />
      <Route
        path="/styleguide"
        element={
          <PrivateRoute>
            <Styleguide />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
